export default __webpack_public_path__ + "static/media/1734765_orig.96e81526.jpeg";